export enum MainRole {
    USER = "user",
    ADMIN = "admin",
    DISTRIBUTOR = "distributor"
}